import {
  AutomationActionDoceboEnrollDenormalized,
  IAutomationActionTemplateDoceboEnroll
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { joinWithCommaAndAnd } from '../../../../../../../services/enumerate';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { actionActorToString } from '../../shared';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryDoceboEnroll = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateDoceboEnroll
    | AutomationActionDoceboEnrollDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t('Assign **{{ participants }}** to the course **{{ course }}**.', {
            participants:
              joinWithCommaAndAnd(
                a.pplToAdd.map((o) =>
                  actionActorToString(o, expTpl.supportingActors, t)
                ),
                t
              ) || 'someone',
            course: a.target.name || 'TBD'
          })}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
